module.exports = __webpack_public_path__ + "img/intro-2.0af48d8c.png";